import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { ProductForm } from "./ProductForm";
import { api, errMsg, money, PLATFORMS } from "../../lib/api";

export const ProductsTab = ({ onChange }) => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/products").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  useEffect(() => {
    load();
  }, []);

  const save = async (data) => {
    try {
      if (editing?.id) await api.put(`/admin/products/${editing.id}`, data);
      else await api.post("/admin/products", data);
      toast.success("Account saved");
      setEditing(null);
      load();
      onChange();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const remove = async (p) => {
    if (!window.confirm(`Delete ${p.name}?`)) return;
    await api.delete(`/admin/products/${p.id}`).catch((e) => toast.error(errMsg(e)));
    load();
    onChange();
  };

  return (
    <div className="mt-6">
      <button onClick={() => setEditing({})} className="flex items-center gap-2 bg-[#a259ff] px-5 py-3 font-mono text-xs font-bold uppercase tracking-widest text-black" data-testid="admin-add-account-button">
        <Plus className="h-4 w-4" /> Add account
      </button>
      <div className="mt-6 grid gap-3">
        {items.map((p) => (
          <div key={p.id} className="flex flex-wrap items-center gap-4 border border-white/10 bg-[#0f0f16] p-4" data-testid={`admin-product-row-${p.id}`}>
            <img src={p.image} alt="" className="h-14 w-20 object-cover" />
            <div className="min-w-0 flex-1">
              <p className="font-semibold">{p.name}</p>
              <p className="font-mono text-xs text-slate-400">{PLATFORMS[p.platform]?.long} · {p.money} · Rank {p.rank} · Stock {p.stock}</p>
            </div>
            <p className="font-mono">{money(p.price)}</p>
            <button onClick={() => setEditing(p)} className="p-2 text-slate-300 hover:text-[#a259ff]" data-testid={`admin-edit-${p.id}`} aria-label="Edit"><Pencil className="h-4 w-4" /></button>
            <button onClick={() => remove(p)} className="p-2 text-slate-300 hover:text-[#ff3dc8]" data-testid={`admin-delete-${p.id}`} aria-label="Delete"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <Dialog open={Boolean(editing)} onOpenChange={(v) => !v && setEditing(null)}>
        <DialogContent className="max-h-[92vh] overflow-y-auto rounded-none border-white/10 bg-[#0b0b11] text-white sm:max-w-lg" data-testid="admin-product-dialog">
          <DialogTitle className="font-display text-4xl font-normal uppercase">{editing?.id ? "Edit account" : "New account"}</DialogTitle>
          {editing && <ProductForm initial={editing} onSave={save} />}
        </DialogContent>
      </Dialog>
    </div>
  );
};
